import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const NAMES = ['Sarah de Miami', 'José de Caracas', 'María de Madrid', 'Carlos de Bogotá', 'Elena de Lima', 'Miguel de Ciudad de México', 'Ana de Valencia', 'David de Houston', 'Sofía de Santiago', 'Luis de Panamá', 'Valentina de Doral', 'Andrés de Buenos Aires', 'Camila de Orlando', 'Gabriel de Weston', 'Isabella de Maracaibo'];
const PRODUCTS = ['Minerales de Sangre Pack', 'eBook + Audiolibro', 'Acceso completo Pack'];
const PRODUCT_IMAGE = 'https://cdn.magicpatterns.com/uploads/3shVeG5L3mAEoY2y4gJ7Tb/MS-_EBOOK.png';
export function SalesPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentData, setCurrentData] = useState({
    name: NAMES[0],
    product: PRODUCTS[0],
    time: 'Ahora'
  });
  useEffect(() => {
    // Initial delay before starting the loop
    const startTimeout = setTimeout(() => {
      setIsVisible(true);
    }, 2000);
    return () => clearTimeout(startTimeout);
  }, []);
  useEffect(() => {
    let timeoutId: NodeJS.Timeout;
    if (isVisible) {
      // Hide after 3 seconds
      timeoutId = setTimeout(() => {
        setIsVisible(false);
      }, 3000);
    } else {
      // Show again after 5 seconds with new data
      timeoutId = setTimeout(() => {
        const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
        const randomProduct = PRODUCTS[Math.floor(Math.random() * PRODUCTS.length)];
        setCurrentData({
          name: randomName,
          product: randomProduct,
          time: 'Ahora'
        });
        setIsVisible(true);
      }, 5000);
    }
    return () => clearTimeout(timeoutId);
  }, [isVisible]);
  return <AnimatePresence data-id="element-235">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 100,
      scale: 0.9
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.95
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 25
    }} className="fixed bottom-6 left-4 right-4 z-50 md:hidden" data-id="element-236">
          <div className="mx-auto max-w-sm bg-dark-800/80 backdrop-blur-xl border border-white/10 rounded-2xl shadow-2xl shadow-black/50 p-3 flex items-center gap-3 overflow-hidden" data-id="element-237">
            {/* Product Image */}
            <div className="relative flex-shrink-0 w-12 h-12 bg-dark-900 rounded-xl overflow-hidden border border-white/5" data-id="element-238">
              <img src={PRODUCT_IMAGE} alt="Product" className="w-full h-full object-cover" data-id="element-239" />
            </div>

            {/* Content */}
            <div className="flex-1 min-w-0" data-id="element-240">
              <div className="flex items-baseline justify-between mb-0.5" data-id="element-241">
                <h4 className="text-[13px] font-semibold text-white truncate pr-2" data-id="element-242">
                  {currentData.name}
                </h4>
                <span className="text-[10px] text-white/40 flex-shrink-0" data-id="element-243">
                  {currentData.time}
                </span>
              </div>
              <p className="text-[12px] text-white/70 leading-tight truncate" data-id="element-244">
                compró{' '}
                <span className="text-white font-medium" data-id="element-245">
                  {currentData.product}
                </span>
              </p>
              <p className="text-[12px] text-gold-400 font-medium mt-0.5" data-id="element-246">
                $9.97
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}